import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { MULTI_SESSION_LIMIT_ACTION_TYPE } from "./multi-session-limit.action";
import { MultiSessionLimitState } from "./multi-session-limit.model";

const INITIAL_STATE: MultiSessionLimitState = {
	multiSessionLimits: undefined,
};

export function multiSessionLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): MultiSessionLimitState {
	switch (action.type) {
		case MULTI_SESSION_LIMIT_ACTION_TYPE.getSuccess:
		case MULTI_SESSION_LIMIT_ACTION_TYPE.updateSuccess:
		case MULTI_SESSION_LIMIT_ACTION_TYPE.removeSuccess: {
			return updateState(state, {
				multiSessionLimits: action.payload,
			});
		}
		case MULTI_SESSION_LIMIT_ACTION_TYPE.clear: {
			return INITIAL_STATE;
		}
		default:
			return state;
	}
}
